import upperFirst from 'lodash.upperfirst';
import camelcase from 'lodash.camelcase';
const getEntityData = (entity, schema) => {
  const publishedDocType = `published_${entity}`;
  const publishedEntityType = `Published${upperFirst(camelcase(entity))}`;
  if (schema) {
    const {
      interfaces,
      [entity]: {
        interfaces: nestedInterfaces
      } = {}
    } = schema || {};
    const interfacesToCheck = interfaces || nestedInterfaces;
    if (interfacesToCheck && !interfacesToCheck.includes('publish/publishable')) {
      return {
        entity,
        docType: entity,
        entityType: upperFirst(camelcase(entity))
      };
    }
  }
  return {
    entity,
    docType: publishedDocType,
    entityType: publishedEntityType
  };
};
export default getEntityData;
//# sourceMappingURL=get-entity-data.js.map